import {useAppContext} from "../context/AppContext";
import InternalSummaryPanel from "../app-components/message/InternalSummaryPanel";
import CompareSummaryPanel from "../app-components/CompareSummaryPanel";
import ProjectInfo from "../app-components/ProjectInfo";
import React from "react";
import {Divider} from "antd";

export default function OverviewPopup() {
    const {appContext, getSelectedHistory} = useAppContext()

    return (
      <>
        {getSelectedHistory()?.type === "Check" && (
          <>
            <ProjectInfo
              report={false}
              autoHeight={true}
              showNotes={true}
              folderName={
                getSelectedHistory()?.selection.base.project?.information
                  ?.folderName
              }
              title={
                getSelectedHistory()?.selection.base.project?.information.title
              }
              descriptions={
                getSelectedHistory()?.selection.base.project?.information
                  .descriptions
              }
              planTitle={getSelectedHistory()?.selection.base.plan?.plan?.title}
              version={
                getSelectedHistory()?.selection.base.project?.projectFiles &&
                getSelectedHistory()?.selection.base.project?.projectFiles
                  .length > 0 &&
                getSelectedHistory()?.selection.base.plan?.plan?.version
              }
            />
            <Divider />
            <InternalSummaryPanel
              summary={getSelectedHistory()?.summary?.base}
              calculation_tolerances={
                getSelectedHistory()?.calculation_tolerances
              }
              report={false}
            />
          </>
        )}

        {getSelectedHistory()?.type === "Comparison" && (
          <>
            <div style={{ display: "flex", alignItems: "start", gap: 16 }}>
              <ProjectInfo
                report={false}
                autoHeight={true}
                showNotes={true}
                folderName={
                  getSelectedHistory()?.selection.base.project?.information
                    ?.folderName
                }
                title={
                  getSelectedHistory()?.selection.base.project?.information
                    .title
                }
                descriptions={
                  getSelectedHistory()?.selection.base.project?.information
                    .descriptions
                }
                planTitle={
                  getSelectedHistory()?.selection.base.plan?.plan?.title
                }
                version={
                  getSelectedHistory()?.selection.base.project?.projectFiles &&
                  getSelectedHistory()?.selection.base.project?.projectFiles
                    .length > 0 &&
                  getSelectedHistory()?.selection.base.plan?.plan?.version
                }
              />
              <ProjectInfo
                report={false}
                autoHeight={true}
                showNotes={true}
                folderName={
                  getSelectedHistory()?.selection.compare.project?.information
                    ?.folderName
                }
                title={
                  getSelectedHistory()?.selection.compare.project?.information
                    .title
                }
                descriptions={
                  getSelectedHistory()?.selection.compare.project?.information
                    .descriptions
                }
                planTitle={
                  getSelectedHistory()?.selection.compare.plan?.plan?.title
                }
                version={
                  getSelectedHistory()?.selection.compare.project
                    ?.projectFiles &&
                  getSelectedHistory()?.selection.compare.project?.projectFiles
                    .length > 0 &&
                  getSelectedHistory()?.selection.compare.plan?.plan?.version
                }
              />
            </div>
            <Divider />
            <CompareSummaryPanel
              summary={getSelectedHistory()?.summary}
              report={false}
              plan={{
                base: getSelectedHistory()?.selection?.base?.plan,
                compare: getSelectedHistory()?.selection?.compare?.plan,
              }}
              wsel={getSelectedHistory()?.wsel}
              filter={getSelectedHistory()?.page?.filter}
              preparing={false}
            />
          </>
        )}
      </>
    );
}